import { CachedImages } from '@gem/call/Removable/stores/CachedImages/CachedImages';
import { RemoteImageObject } from '@gem/modules/remote-storage';

export async function preloadImage(url: string): Promise<boolean> {
  if (!url || CachedImages.isCachedImage(url)) {
    return false;
  }

  return new Promise((resolve) => {
    const img = new RemoteImageObject();
    img.onload = (): void => {
      CachedImages.addCachedImage(url, true);
      resolve(true);
    };
    img.onerror = (): void => {
      CachedImages.addCachedImage(url, false);
      resolve(false);
    };
    img.src = url;
  });
}
